import { gql } from '@apollo/client';
import { CHAPTER_FIELDS } from './chapter';
import { VIDEO_FIELDS } from './video';

export const CONCEPT_FIELDS = gql`
  ${CHAPTER_FIELDS}
  ${VIDEO_FIELDS}
  fragment ConceptFields on Concept {
    id
    name
    demo
    status
    typeId
    entitlement {
      id
      name
    }
    topicId
    topic {
      id
      name
      typeId
    }
    chapterId
    chapter {
      ...ChapterFields
    }
    videos {
      ...VideoFields
    }
    userNote {
      id
      userId
      conceptId
      note
      updatedAt
    }
    userChapter {
      id
      userId
      conceptId
      explanation
      updatedAt
    }
  }
`;

// used in cache updator
export const STATUS_CONCEPT_FRAGMENT = gql`
  fragment ConceptStatus on Concept {
    status
  }
`;

// used in cache updator
export const UPSERT_CONCEPT_NOTE_FRAGMENT = gql`
  fragment UpsertConceptNoteFragment on Concept {
    userNote {
      userId
      note
      conceptId
      createdAt
      updatedAt
    }
  }
`;
// used in cache updator
export const UPSERT_CONCEPT_CHAPTER_FRAGMENT = gql`
  fragment UpsertConceptChapterFragment on Concept {
    userChapter {
      userId
      explanation
      conceptId
      createdAt
      updatedAt
    }
  }
`;
